/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const postSalesWeeklyReport = (params) =>
  makeApiCall(`/push-products/sales-weekly-summary`, 'POST', params, false);

export const postSalesWeeklyReportExport = (params) =>
  makeApiCall(`/push-products/sales-weekly-summary/export`, 'POST', params, false);
